import axios from 'axios';
import { proxyUrlMode as currentEnv } from '../setupEnvironment';

const isDev = process.env.NODE_ENV === 'development';
const env = currentEnv === 'prod' ? 'api' : 'api-preprod';
const host = isDev ? '/api/nike' : `https://${env}.nike.com`;

const storeStatusOpened = 'OPEN';
const storeStatusUnopened = 'UNOPENED';
const storeStatusClosed = 'CLOSED';

const fetchStoreNumbers = async (updatedCountry) => {
  const url = `${host}/store/store_views/v2?search=((address.country==(${updatedCountry}))%20and%20published==false)&fields=storeNumber,storeStatus&count=3000`;
  
  try {
    const response = await axios({
      method: 'GET',
      url: url,
      headers: {
        'nike-api-caller-id': 'com.nike:retail.sim',
        'Accept': 'application/json'
      },
      timeout: 10000 // 10 second timeout
    });

    const data = response?.data;
    const sortAlphaNum = (a, b) => a.localeCompare(b, 'en', { numeric: true });
    
    // Filter and map store numbers
    const listOfStoreNumbers = [...new Set(
      data?.objects
        ?.filter(store => 
          store.storeStatus === storeStatusOpened ||
          store.storeStatus === storeStatusUnopened ||
          store.storeStatus === storeStatusClosed
        )
        ?.map(store => store.storeNumber)
        ?.filter(Boolean) // Remove any null/undefined values
    )];
    
    listOfStoreNumbers.sort(sortAlphaNum);
    
    const numberArray = listOfStoreNumbers.map(number => ({
      value: number,
      label: number,
    }));
    
    return numberArray;
  } catch (error) {
    console.error('fetchStoreNumbers failed:', {
      message: error.message,
      url: error.config?.url,
      status: error.response?.status,
      country: updatedCountry
    });
    
    // Return empty array instead of crashing
    return [];
  }
};

export default fetchStoreNumbers;
